export default __webpack_public_path__ + "static/media/android.e7220992.png";